var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/**
 * Retrieves the last item from an array
 * @param items
 * @return The last item in the array
 * */
export var lastItem = function (items) {
    if (items.length < 1) {
        return null;
    }
    return items[items.length - 1];
};
export var sortedBy = function (array, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback, reversed) {
    if (reversed === void 0) { reversed = false; }
    var sortedArray = __spreadArray([], array);
    sortedArray.sort(function (previous, current) {
        var previousKey = callback(previous);
        var currentKey = callback(current);
        // eslint-disable-next-line no-restricted-globals
        var isNumber = !isNaN(previousKey) || !isNaN(currentKey);
        if (isNumber) {
            if (reversed) {
                return currentKey - previousKey;
            }
            return previousKey - currentKey;
        }
        if (reversed) {
            return previousKey.localeCompare(currentKey);
        }
        return currentKey.localeCompare(previousKey);
    });
    return sortedArray;
};
export var sortedByDescending = function (array, // eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) { return sortedBy(array, callback, true); };
export var appendItem = function (array, item) { return __spreadArray(__spreadArray([], array), [item]); };
